const normalizeId = (value) => {
    const id = Number(value);
    return Number.isNaN(id) ? null : id;
};

const collectManagedClassIds = (user) => {
    const ids = new Set();

    if (user?.teaching_class?.id) {
        const primaryId = normalizeId(user.teaching_class.id);
        if (primaryId !== null) ids.add(primaryId);
    }

    if (Array.isArray(user?.teaching_classes)) {
        user.teaching_classes.forEach((cls) => {
            const classId = normalizeId(cls?.id ?? cls);
            if (classId !== null) ids.add(classId);
        });
    }

    return ids;
};

export const filterClassesForStaffUser = (classes = [], user) => {
    if (!Array.isArray(classes)) return [];
    if (!user || user.role !== 'teacher') return classes;

    const managedIds = collectManagedClassIds(user);

    return classes.filter((cls) => {
        if (!cls) return false;
        const classId = normalizeId(cls.id);
        if (classId !== null && managedIds.has(classId)) return true;
        return cls.teacher_id === user.id;
    });
};
